// import { Icon } from "@iconify/react";
import useStyles from "../../styles";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper
} from "@mui/material";
// import Button from "../../../../components/Button";
import { useEffect, useState } from "react";
// import Modal from "../../../../components/Modal";
// import { useNavigate } from "react-router-dom";
// import ButtonCount from "../../../../components/ButtonCount";
import NotFounditem from "../../../error/NotFound";
import nosearch from "../../../../assets/images/no-search.svg";
import { httprequest } from "../../../../data/api";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PageLoader from "../../../../components/PageLoader";
// import StudentResults from "../../../../dummy_data/StudentResult.json";
import { toast } from "react-toastify";
import Layout from "../../../../components/Layout";
import PageTitle from "../../../../components/PageTitle";
// import { CardSearch } from "../../../../components/CardSearch";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";

// END POINT CALLS
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/broad-sheet/";
const CLASSES_ENDPOINT = "/api/v1/class";

const BroadSheet = () => {
  const classes = useStyles();
  const [value, setValue] = useState("");
  // const [searchResult, setSearchResult] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  // const [searchTerm, setSearchTerm] = useState("");
  const [classGrades, setClassGrades] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);

  /**
 * Fetches all physical classes from the server and updates the state.
 * @function
 * @returns {void}
 * @description This function makes an HTTP GET request to the CLASSES_ENDPOINT,
 * filters the response to only include physical classes, and updates the classData state.
 * It also manages the loading state with setIsPageFetching.
 */
  const getAllClasses = () => {
    setIsPageFetching(true);
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setIsPageFetching(false);
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
 * Fetches all terms for a specific session and updates the state.
 * @function
 * @param {string|number} Session_ID - The ID of the session to get terms for.
 * @returns {void}
 * @description Makes an HTTP GET request to TERM_ENDPOINT and filters the results
 * to only include terms matching the provided Session_ID.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Fetches all sessions from the server and updates the state.
 * @async
 * @function
 * @returns {Promise<void>}
 * @description Makes an asynchronous HTTP GET request to GET_SESSIONS endpoint,
 * updates the allSessions state with the response data, and sets the active session.
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Finds the active term in the current session.
 * @type {Object}
 * @description This variable holds the term object where is_current is true,
 * from the activeSession's terms array.
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session change events.
 * @function
 * @param {Object} e - The event object from the select input.
 * @returns {void}
 * @description Gets the selected Session_ID from the event and calls getAllTerms with it.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Fetches all class results for a specific class and term.
 * @async
 * @function
 * @param {string|number} classID - The ID of the class to get results for.
 * @param {string|number} termId - The ID of the term to get results for.
 * @returns {Promise<void>}
 * @description Makes an asynchronous GET request to GET_CLASS_GRADES endpoint,
 * updates the classGrades and filteredStudents state with the response data.
 */
  const handleGetAllClassResult = async (classID, termId) => {
    setIsPageFetching(true);
    try {
      const res = await httprequest.get(`${GET_CLASS_GRADES}${classID}?term_id=${termId}`);
      setIsPageFetching(false);
      setClassGrades(res?.data?.data);
      setFilteredStudents(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message);
    }
  };

  /**
 * @effect
 * @description On component mount, fetches all sessions, terms, and classes.
 */
  useEffect(() => {
    getAllSessions();
    getAllTerms();
    getAllClasses();
  }, []);

  /**
 * @effect
 * @description When active_term_session changes, updates the selected term state.
 * @deps active_term_session
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
    }
  }, [active_term_session]);

  /**
 * @effect
 * @description When activeSession changes, gets all terms for the active session.
 * @deps activeSession
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  /**
 * @effect
 * @description When classesData or active_term_session changes, sets the first class
 * as default and fetches its results for the active term.
 * @deps classesData, active_term_session
 */
  useEffect(() => {
    if (classesData?.length > 0 && active_term_session?.id) {
      const class_value = classesData[0]?.id;
      setValue(class_value);
      const params = {
        term_id: active_term_session.id
      };

      handleGetAllClassResult(class_value, params.term_id);
    }
  }, [classesData, active_term_session]);

  /**
 * Handles class change events and fetches results for the new class.
 * @function
 * @param {Object} event - The event object (unused in this case).
 * @param {string} newValue - The new class ID that was selected.
 * @description Updates the selected class value and fetches results for the new class
 * using the currently selected term.
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);

    handleGetAllClassResult(newValue, aselectedTerm);
  };

  /**
 * Handles term change events and fetches results for the new term.
 * @function
 * @param {Object} event - The event object from the select input.
 * @description Gets the selected term ID from the event, updates the selected term state,
 * and fetches results for the current class with the new term.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    handleGetAllClassResult(value, selectedTermId);
  };

  /**
 * An array of unique students from the filtered class grades.
 * @type {Array<Object>}
 * @description This array contains student objects with id and name properties,
 * derived from the filteredStudents data, with duplicates removed by ID.
 */
  const students = Array.from(
    new Map(
      (filteredStudents?.sheet || [])
        .flatMap((entry) => (entry?.students || []).map((student) => [
          student?.id,
          { id: student?.id, name: `${student?.last_name} ${student?.first_name}` }
        ])
        )
    ).values()
  );

  /**
 * An array of subjects from the class grades.
 * @type {Array<Object>}
 * @description This array contains subject objects from the classGrades data.
 * Returns an empty array if no subjects are available.
 */
  const subjects = classGrades?.sheet?.map((entry) => entry?.subject) || [];

  return (
    <Layout children={
      <>
        <PageTitle
          title="Examination Broadsheet"
          subtitle="See all Student Examination Result"
          // button={
          //   <div>
          //     <Button
          //       variant="primary"
          //       buttonSize="fluid"
          //       color="btndefault"
          //       // onClick={() => handleCreateNoteModal()}
          //       buttonName="Add Result to Broadsheet"
          //     />
          //   </div>
          // }
        />
        <TabContext value={value}>
          {classesData.length > 0 && (
            <div className="tablist-container">
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                {classesData?.map((data, i) => {
                  return (
                    <Tab key={i} value={data?.id} label={data?.class_name} />
                  );
                })}
              </Tabs>
            </div>
          )}

          <div className="page-content margin-top-16">
            <div className={classes.headinfo}>
              {/* {classGrades?.sheet?.length > 0 && (
                <div className={`${classes.searchcont} margin-bottom-10`}>
                  <CardSearch
                    placeholder="Search Student Result"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
              )} */}
              <div className="flex gap-10 align-items-end margin-top-5">
                <div>
                  {activeSession?.id && (
                    <SelectGroup
                      children={
                        <select
                          defaultValue={activeSession?.id}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
                <div>
                  {active_term_session?.id && (
                    <SelectGroup
                      children={
                        <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            {classesData?.map((data, i) => (
              <TabPanel className="tabpanel-overide" key={i} value={data?.id}>
                {isPageFetching ? (
                  <PageLoader />
                ) : classGrades?.sheet === 0 ? (
                  <div className={classes.notfound}>
                    <NotFounditem
                      img={nosearch}
                      title="No Exam BroadSheet Found"
                      subtitle="No Broadsheet has been added to the list."
                    />
                  </div>
                ) : (
                  <TableContainer component={Paper} style={{ overflowX: "auto" }} className={classes.tableContainer}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell className={`${classes.headerCell} ${classes.firstColumn}`} rowSpan={2}>Student Name</TableCell>
                          {subjects.map((subject) => (
                            <>
                              <TableCell className={classes.headerCell} colSpan={6} align="center">
                                {subject?.name}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                        <TableRow>
                          {subjects.map((_, subjectIndex) => (
                            <>
                              <TableCell className={classes.subHeaderCell} align="center">CA1</TableCell>
                              <TableCell className={classes.subHeaderCell} align="center">CA2</TableCell>
                              <TableCell className={classes.subHeaderCell} align="center">Total CA</TableCell>
                              <TableCell className={classes.subHeaderCell} align="center">Exam</TableCell>
                              <TableCell className={classes.subHeaderCell} align="center">Total</TableCell>
                              <TableCell className={`${classes.subHeaderCell} ${
                                subjectIndex === subjects.length - 1 ? "" : classes.separator
                              }`} align="center"
                              >Grade
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {students.map((student, index) => (
                          <TableRow key={student.id} className={index % 2 === 0 ? "" : classes.bodyRowOdd}>
                            <TableCell className={`${classes.secondRowCol}`}>{student?.name}</TableCell>
                            {subjects.map((subject, subjectIndex) => {
                              const studentScores = filteredStudents?.sheet
                                ?.find((entry) => entry?.subject?.id === subject?.id)
                                ?.students?.find((s) => s?.id === student?.id);

                              return studentScores ? (
                                <>
                                  <TableCell className={classes.bodyCell} align="center">{studentScores?.scores?.CA_scores?.CA1 || "-"}</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">{studentScores?.scores?.CA_scores?.CA2 || "-"}</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">{studentScores?.scores?.CA_total || "-"}</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">{studentScores?.scores?.exam_score || "-"}</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">{studentScores?.scores?.total || "-"}</TableCell>
                                  <TableCell className={`${classes.bodyCell} ${
                                    subjectIndex === subjects.length - 1 ? "" : classes.separator
                                  }`} align="center"
                                  >{studentScores.scores.grade || "-"}
                                  </TableCell>
                                </>
                              ) : (
                                <>
                                  <TableCell className={classes.bodyCell} align="center">-</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">-</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">-</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">-</TableCell>
                                  <TableCell className={classes.bodyCell} align="center">-</TableCell>
                                  <TableCell className={`${classes.bodyCell} ${
                                    subjectIndex === subjects.length - 1 ? "" : classes.separator
                                  }`} align="center"
                                  >-
                                  </TableCell>
                                </>
                              );
                            })}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </TabPanel>
            ))}
          </div>
        </TabContext>
        {/* <div className="flex justify-items-space Blockspacing">
          <div className={classes.contentpadding}>
            <ButtonCount func={() => navigate("")} title="Student Count" />
          </div>
          <div className={classes.employee}>
            <p>Class Teacher: </p>
            <h4 onClick={() => navigate("/employees")}>Euguen Adaovore</h4>
          </div>
        </div> */}
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default BroadSheet;
